import { InputTypes, PaymentFormField } from '@cashier/cashier-model';

export const processFieldWithSelectType = (
  field: PaymentFormField,
): PaymentFormField => {
  const { params } = field;

  if (
    field.value === null &&
    [InputTypes.Select].includes(field.type) &&
    params?.options?.length === 1
  ) {
    return {
      ...field,
      value: params.options[0].value,
      isDisabled: true,
    };
  }

  return field;
};

export const processFieldsWithSelectType = (fields: PaymentFormField[]) => {
  return fields.map(processFieldWithSelectType);
};
